{
  "auth": {
    "user_pool_id": "eu-west-1_QcmV9HQ35",
    "aws_region": "eu-west-1",
    "user_pool_client_id": "22t2nvcv143m1blbmh1ftjh2o7",
    "identity_pool_id": "eu-west-1:3dfc9b0a-b8b7-4e01-8bce-a977cbc995bc",
    "mfa_methods": [],
    "standard_required_attributes": [
      "email"
    ],
    "username_attributes": [
      "email"
    ],
    "user_verification_types": [
      "email"
    ],
    "groups": [
      {
        "ADMINS": {
          "precedence": 0
        }
      },
      {
        "USERS": {
          "precedence": 1
        }
      }
    ],
    "mfa_configuration": "NONE",
    "password_policy": {
      "min_length": 8,
      "require_lowercase": true,
      "require_numbers": true,
      "require_symbols": true,
      "require_uppercase": true
    },
    "unauthenticated_identities_enabled": true
  },
  "data": {
    "url": "https://lbsmb7fdvvea5p5inf7ajpzxhi.appsync-api.eu-west-1.amazonaws.com/graphql",
    "aws_region": "eu-west-1",
    "default_authorization_type": "AMAZON_COGNITO_USER_POOLS",
    "authorization_types": [
      "AWS_IAM"
    ],
    "model_introspection": {
      "version": 1,
      "models": {
        "Todo": {
          "name": "Todo",
          "fields": {
            "id": {
              "name": "id",
              "isArray": false,
              "type": "ID",
              "isRequired": true,
              "attributes": []
            },
            "content": {
              "name": "content",
              "isArray": false,
              "type": "String",
              "isRequired": false,
              "attributes": []
            },
            "createdAt": {
              "name": "createdAt",
              "isArray": false,
              "type": "AWSDateTime",
              "isRequired": false,
              "attributes": [],
              "isReadOnly": true
            },
            "updatedAt": {
              "name": "updatedAt",
              "isArray": false,
              "type": "AWSDateTime",
              "isRequired": false,
              "attributes": [],
              "isReadOnly": true
            }
          },
          "syncable": true,
          "pluralName": "Todos",
          "attributes": [
            {
              "type": "model",
              "properties": {}
            },
            {
              "type": "auth",
              "properties": {
                "rules": [
                  {
                    "provider": "userPools",
                    "ownerField": "owner",
                    "allow": "owner",
                    "identityClaim": "cognito:username",
                    "operations": [
                      "create",
                      "update",
                      "delete",
                      "read"
                    ]
                  },
                  {
                    "groupClaim": "cognito:groups",
                    "provider": "userPools",
                    "allow": "groups",
                    "groups": [
                      "admin"
                    ],
                    "operations": [
                      "create",
                      "update",
                      "delete",
                      "read"
                    ]
                  }
                ]
              }
            }
          ],
          "primaryKeyInfo": {
            "isCustomPrimaryKey": false,
            "primaryKeyFieldName": "id",
            "sortKeyFieldNames": []
          }
        },
        "CompanyOnboarding": {
          "name": "CompanyOnboarding",
          "fields": {
            "id": {
              "name": "id",
              "isArray": false,
              "type": "ID",
              "isRequired": true,
              "attributes": []
            },
            "owner": {
              "name": "owner",
              "isArray": false,
              "type": "String",
              "isRequired": false,
              "attributes": []
            },
            "companyName": {
              "name": "companyName",
              "isArray": false,
              "type": "String",
              "isRequired": false,
              "attributes": []
            },
            "domainActivities": {
              "name": "domainActivities",
              "isArray": true,
              "type": "String",
              "isRequired": false,
              "attributes": [],
              "isArrayNullable": true
            },
            "otherActivityDescription": {
              "name": "otherActivityDescription",
              "isArray": false,
              "type": "String",
              "isRequired": false,
              "attributes": []
            },
            "legalStatus": {
              "name": "legalStatus",
              "isArray": false,
              "type": "String",
              "isRequired": false,
              "attributes": []
            },
            "businessType": {
              "name": "businessType",
              "isArray": false,
              "type": "String",
              "isRequired": false,
              "attributes": []
            },
            "capital": {
              "name": "capital",
              "isArray": false,
              "type": "Float",
              "isRequired": false,
              "attributes": []
            },
            "domiciliationRegion": {
              "name": "domiciliationRegion",
              "isArray": false,
              "type": "String",
              "isRequired": false,
              "attributes": []
            },
            "domiciliationLanguage": {
              "name": "domiciliationLanguage",
              "isArray": false,
              "type": "String",
              "isRequired": false,
              "attributes": []
            },
            "domiciliationLocation": {
              "name": "domiciliationLocation",
              "isArray": false,
              "type": "String",
              "isRequired": false,
              "attributes": []
            },
            "coordinatesAddress": {
              "name": "coordinatesAddress",
              "isArray": false,
              "type": "String",
              "isRequired": false,
              "attributes": []
            },
            "coordinatesAddressComplement": {
              "name": "coordinatesAddressComplement",
              "isArray": false,
              "type": "String",
              "isRequired": false,
              "attributes": []
            },
            "coordinatesCity": {
              "name": "coordinatesCity",
              "isArray": false,
              "type": "String",
              "isRequired": false,
              "attributes": []
            },
            "coordinatesPostalCode": {
              "name": "coordinatesPostalCode",
              "isArray": false,
              "type": "String",
              "isRequired": false,
              "attributes": []
            },
            "financialData": {
              "name": "financialData",
              "isArray": false,
              "type": {
                "nonModel": "CompanyOnboardingFinancialData"
              },
              "isRequired": false,
              "attributes": []
            },
            "directors": {
              "name": "directors",
              "isArray": true,
              "type": {
                "model": "CompanyOnboardingDirectors"
              },
              "isRequired": false,
              "attributes": [],
              "isArrayNullable": true,
              "association": {
                "connectionType": "HAS_MANY",
                "associatedWith": [
                  "companyOnboardingId"
                ]
              }
            },
            "lastSaved": {
              "name": "lastSaved",
              "isArray": false,
              "type": "AWSDateTime",
              "isRequired": false,
              "attributes": []
            },
            "isCompleted": {
              "name": "isCompleted",
              "isArray": false,
              "type": "Boolean",
              "isRequired": false,
              "attributes": []
            },
            "paid": {
              "name": "paid",
              "isArray": false,
              "type": "Boolean",
              "isRequired": false,
              "attributes": []
            },
            "paymentDate": {
              "name": "paymentDate",
              "isArray": false,
              "type": "AWSDateTime",
              "isRequired": false,
              "attributes": []
            },
            "identityPoolId": {
              "name": "identityPoolId",
              "isArray": false,
              "type": "String",
              "isRequired": false,
              "attributes": []
            },
            "stripeId": {
              "name": "stripeId",
              "isArray": false,
              "type": "String",
              "isRequired": false,
              "attributes": []
            },
            "meetingScheduled": {
              "name": "meetingScheduled",
              "isArray": false,
              "type": "Boolean",
              "isRequired": false,
              "attributes": []
            },
            "meetingDate": {
              "name": "meetingDate",
              "isArray": false,
              "type": "AWSDateTime",
              "isRequired": false,
              "attributes": []
            },
            "constitutionDate": {
              "name": "constitutionDate",
              "isArray": false,
              "type": "AWSDateTime",
              "isRequired": false,
              "attributes": []
            },
            "plan": {
              "name": "plan",
              "isArray": false,
              "type": "String",
              "isRequired": false,
              "attributes": []
            },
            "paymentMethod": {
              "name": "paymentMethod",
              "isArray": false,
              "type": {
                "enum": "CompanyOnboardingPaymentMethod"
              },
              "isRequired": false,
              "attributes": []
            },
            "paymentMethodSelectedAt": {
              "name": "paymentMethodSelectedAt",
              "isArray": false,
              "type": "AWSDateTime",
              "isRequired": false,
              "attributes": []
            },
            "status": {
              "name": "status",
              "isArray": false,
              "type": {
                "enum": "CompanyOnboardingStatus"
              },
              "isRequired": false,
              "attributes": []
            },
            "onboardingStatus": {
              "name": "onboardingStatus",
              "isArray": false,
              "type": {
                "enum": "CompanyOnboardingOnboardingStatus"
              },
              "isRequired": false,
              "attributes": []
            },
            "accountantReviewStatus": {
              "name": "accountantReviewStatus",
              "isArray": false,
              "type": {
                "enum": "CompanyOnboardingAccountantReviewStatus"
              },
              "isRequired": false,
              "attributes": []
            },
            "onboardingManagerId": {
              "name": "onboardingManagerId",
              "isArray": false,
              "type": "String",
              "isRequired": false,
              "attributes": []
            },
            "documents": {
              "name": "documents",
              "isArray": true,
              "type": {
                "model": "CompanyOnboardingDocument"
              },
              "isRequired": false,
              "attributes": [],
              "isArrayNullable": true,
              "association": {
                "connectionType": "HAS_MANY",
                "associatedWith": [
                  "companyOnboardingId"
                ]
              }
            },
            "checkpoints": {
              "name": "checkpoints",
              "isArray": false,
              "type": {
                "model": "CompanyCheckpoints"
              },
              "isRequired": false,
              "attributes": [],
              "association": {
                "connectionType": "HAS_ONE",
                "associatedWith": [
                  "companyOnboardingId"
                ],
                "targetNames": []
              }
            },
            "comments": {
              "name": "comments",
              "isArray": true,
              "type": {
                "model": "CompanyComment"
              },
              "isRequired": false,
              "attributes": [],
              "isArrayNullable": true,
              "association": {
                "connectionType": "HAS_MANY",
                "associatedWith": [
                  "companyOnboardingId"
                ]
              }
            },
            "createdAt": {
              "name": "createdAt",
              "isArray": false,
              "type": "AWSDateTime",
              "isRequired": false,
              "attributes": [],
              "isReadOnly": true
            },
            "updatedAt": {
              "name": "updatedAt",
              "isArray": false,
              "type": "AWSDateTime",
              "isRequired": false,
              "attributes": [],
              "isReadOnly": true
            }
          },
          "syncable": true,
          "pluralName": "CompanyOnboardings",
          "attributes": [
            {
              "type": "model",
              "properties": {}
            },
            {
              "type": "key",
              "properties": {
                "fields": [
                  "id"
                ]
              }
            },
            {
              "type": "key",
              "properties": {
                "name": "companyOnboardingsByOnboardingManagerId",
                "queryField": "listCompanyOnboardingByOnboardingManagerId",
                "fields": [
                  "onboardingManagerId"
                ]
              }
            },
            {
              "type": "auth",
              "properties": {
                "rules": [
                  {
                    "provider": "userPools",
                    "ownerField": "owner",
                    "allow": "owner",
                    "identityClaim": "cognito:username",
                    "operations": [
                      "create",
                      "update",
                      "delete",
                      "read"
                    ]
                  },
                  {
                    "groupClaim": "cognito:groups",
                    "provider": "userPools",
                    "allow": "groups",
                    "groups": [
                      "ADMINS"
                    ],
                    "operations": [
                      "create",
                      "update",
                      "delete",
                      "read"
                    ]
                  }
                ]
              }
            }
          ],
          "primaryKeyInfo": {
            "isCustomPrimaryKey": false,
            "primaryKeyFieldName": "id",
            "sortKeyFieldNames": []
          }
        },
        "CompanyOnboardingDirectors": {
          "name": "CompanyOnboardingDirectors",
          "fields": {
            "id": {
              "name": "id",
              "isArray": false,
              "type": "ID",
              "isRequired": true,
              "attributes": []
            },
            "firstName": {
              "name": "firstName",
              "isArray": false,
              "type": "String",
              "isRequired": false,
              "attributes": []
            },
            "lastName": {
              "name": "lastName",
              "isArray": false,
              "type": "String",
              "isRequired": false,
              "attributes": []
            },
            "completeName": {
              "name": "completeName",
              "isArray": false,
              "type": "String",
              "isRequired": false,
              "attributes": []
            },
            "email": {
              "name": "email",
              "isArray": true,
              "type": "AWSEmail",
              "isRequired": false,
              "attributes": [],
              "isArrayNullable": true
            },
            "phone": {
              "name": "phone",
              "isArray": true,
              "type": "String",
              "isRequired": false,
              "attributes": [],
              "isArrayNullable": true
            },
            "nationality": {
              "name": "nationality",
              "isArray": false,
              "type": "String",
              "isRequired": false,
              "attributes": []
            },
            "civilStatus": {
              "name": "civilStatus",
              "isArray": false,
              "type": "String",
              "isRequired": false,
              "attributes": []
            },
            "addressLine1": {
              "name": "addressLine1",
              "isArray": false,
              "type": "String",
              "isRequired": false,
              "attributes": []
            },
            "addressLine2": {
              "name": "addressLine2",
              "isArray": false,
              "type": "String",
              "isRequired": false,
              "attributes": []
            },
            "postalCode": {
              "name": "postalCode",
              "isArray": false,
              "type": "String",
              "isRequired": false,
              "attributes": []
            },
            "city": {
              "name": "city",
              "isArray": false,
              "type": "String",
              "isRequired": false,
              "attributes": []
            },
            "country": {
              "name": "country",
              "isArray": false,
              "type": "String",
              "isRequired": false,
              "attributes": []
            },
            "isAdministrator": {
              "name": "isAdministrator",
              "isArray": false,
              "type": "Boolean",
              "isRequired": false,
              "attributes": []
            },
            "isShareholder": {
              "name": "isShareholder",
              "isArray": false,
              "type": "Boolean",
              "isRequired": false,
              "attributes": []
            },
            "sharePercentage": {
              "name": "sharePercentage",
              "isArray": false,
              "type": "Float",
              "isRequired": false,
              "attributes": []
            },
            "identityDocumentFileKey": {
              "name": "identityDocumentFileKey",
              "isArray": false,
              "type": "String",
              "isRequired": false,
              "attributes": []
            },
            "residenceProofDocumentFileKey": {
              "name": "residenceProofDocumentFileKey",
              "isArray": false,
              "type": "String",
              "isRequired": false,
              "attributes": []
            },
            "companyOnboardingId": {
              "name": "companyOnboardingId",
              "isArray": false,
              "type": "ID",
              "isRequired": false,
              "attributes": []
            },
            "companyOnboarding": {
              "name": "companyOnboarding",
              "isArray": false,
              "type": {
                "model": "CompanyOnboarding"
              },
              "isRequired": false,
              "attributes": [],
              "association": {
                "connectionType": "BELONGS_TO",
                "targetNames": [
                  "companyOnboardingId"
                ]
              }
            },
            "documents": {
              "name": "documents",
              "isArray": true,
              "type": {
                "model": "CompanyOnboardingDocument"
              },
              "isRequired": false,
              "attributes": [],
              "isArrayNullable": true,
              "association": {
                "connectionType": "HAS_MANY",
                "associatedWith": [
                  "directorId"
                ]
              }
            },
            "createdAt": {
              "name": "createdAt",
              "isArray": false,
              "type": "AWSDateTime",
              "isRequired": false,
              "attributes": [],
              "isReadOnly": true
            },
            "updatedAt": {
              "name": "updatedAt",
              "isArray": false,
              "type": "AWSDateTime",
              "isRequired": false,
              "attributes": [],
              "isReadOnly": true
            }
          },
          "syncable": true,
          "pluralName": "CompanyOnboardingDirectors",
          "attributes": [
            {
              "type": "model",
              "properties": {}
            },
            {
              "type": "auth",
              "properties": {
                "rules": [
                  {
                    "provider": "userPools",
                    "ownerField": "owner",
                    "allow": "owner",
                    "identityClaim": "cognito:username",
                    "operations": [
                      "create",
                      "update",
                      "delete",
                      "read"
                    ]
                  },
                  {
                    "groupClaim": "cognito:groups",
                    "provider": "userPools",
                    "allow": "groups",
                    "groups": [
                      "ADMINS"
                    ],
                    "operations": [
                      "create",
                      "update",
                      "delete",
                      "read"
                    ]
                  }
                ]
              }
            }
          ],
          "primaryKeyInfo": {
            "isCustomPrimaryKey": false,
            "primaryKeyFieldName": "id",
            "sortKeyFieldNames": []
          }
        },
        "CompanyOnboardingDocument": {
          "name": "CompanyOnboardingDocument",
          "fields": {
            "id": {
              "name": "id",
              "isArray": false,
              "type": "ID",
              "isRequired": true,
              "attributes": []
            },
            "fileKey": {
              "name": "fileKey",
              "isArray": false,
              "type": "String",
              "isRequired": true,
              "attributes": []
            },
            "fileName": {
              "name": "fileName",
              "isArray": false,
              "type": "String",
              "isRequired": true,
              "attributes": []
            },
            "fileSize": {
              "name": "fileSize",
              "isArray": false,
              "type": "Int",
              "isRequired": false,
              "attributes": []
            },
            "mimeType": {
              "name": "mimeType",
              "isArray": false,
              "type": "String",
              "isRequired": false,
              "attributes": []
            },
            "documentType": {
              "name": "documentType",
              "isArray": false,
              "type": {
                "enum": "CompanyOnboardingDocumentDocumentType"
              },
              "isRequired": false,
              "attributes": []
            },
            "companyOnboardingId": {
              "name": "companyOnboardingId",
              "isArray": false,
              "type": "ID",
              "isRequired": false,
              "attributes": []
            },
            "companyOnboarding": {
              "name": "companyOnboarding",
              "isArray": false,
              "type": {
                "model": "CompanyOnboarding"
              },
              "isRequired": false,
              "attributes": [],
              "association": {
                "connectionType": "BELONGS_TO",
                "targetNames": [
                  "companyOnboardingId"
                ]
              }
            },
            "directorId": {
              "name": "directorId",
              "isArray": false,
              "type": "ID",
              "isRequired": false,
              "attributes": []
            },
            "director": {
              "name": "director",
              "isArray": false,
              "type": {
                "model": "CompanyOnboardingDirectors"
              },
              "isRequired": false,
              "attributes": [],
              "association": {
                "connectionType": "BELONGS_TO",
                "targetNames": [
                  "directorId"
                ]
              }
            },
            "checkpointId": {
              "name": "checkpointId",
              "isArray": false,
              "type": "ID",
              "isRequired": false,
              "attributes": []
            },
            "checkpoint": {
              "name": "checkpoint",
              "isArray": false,
              "type": {
                "model": "CompanyCheckpoints"
              },
              "isRequired": false,
              "attributes": [],
              "association": {
                "connectionType": "BELONGS_TO",
                "targetNames": [
                  "checkpointId"
                ]
              }
            },
            "owner": {
              "name": "owner",
              "isArray": false,
              "type": "String",
              "isRequired": false,
              "attributes": []
            },
            "createdAt": {
              "name": "createdAt",
              "isArray": false,
              "type": "AWSDateTime",
              "isRequired": false,
              "attributes": [],
              "isReadOnly": true
            },
            "updatedAt": {
              "name": "updatedAt",
              "isArray": false,
              "type": "AWSDateTime",
              "isRequired": false,
              "attributes": [],
              "isReadOnly": true
            }
          },
          "syncable": true,
          "pluralName": "CompanyOnboardingDocuments",
          "attributes": [
            {
              "type": "model",
              "properties": {}
            },
            {
              "type": "key",
              "properties": {
                "fields": [
                  "id"
                ]
              }
            },
            {
              "type": "auth",
              "properties": {
                "rules": [
                  {
                    "provider": "userPools",
                    "ownerField": "owner",
                    "allow": "owner",
                    "identityClaim": "cognito:username",
                    "operations": [
                      "create",
                      "update",
                      "delete",
                      "read"
                    ]
                  },
                  {
                    "groupClaim": "cognito:groups",
                    "provider": "userPools",
                    "allow": "groups",
                    "groups": [
                      "ADMINS"
                    ],
                    "operations": [
                      "create",
                      "update",
                      "delete",
                      "read"
                    ]
                  }
                ]
              }
            }
          ],
          "primaryKeyInfo": {
            "isCustomPrimaryKey": false,
            "primaryKeyFieldName": "id",
            "sortKeyFieldNames": []
          }
        },
        "CompanyCheckpoints": {
          "name": "CompanyCheckpoints",
          "fields": {
            "id": {
              "name": "id",
              "isArray": false,
              "type": "ID",
              "isRequired": true,
              "attributes": []
            },
            "financialPlan": {
              "name": "financialPlan",
              "isArray": false,
              "type": {
                "enum": "CompanyCheckpointsFinancialPlan"
              },
              "isRequired": false,
              "attributes": []
            },
            "vatRegistration": {
              "name": "vatRegistration",
              "isArray": false,
              "type": {
                "enum": "CompanyCheckpointsVatRegistration"
              },
              "isRequired": false,
              "attributes": []
            },
            "notarialDeed": {
              "name": "notarialDeed",
              "isArray": false,
              "type": {
                "enum": "CompanyCheckpointsNotarialDeed"
              },
              "isRequired": false,
              "attributes": []
            },
            "uboRegister": {
              "name": "uboRegister",
              "isArray": false,
              "type": {
                "enum": "CompanyCheckpointsUboRegister"
              },
              "isRequired": false,
              "attributes": []
            },
            "bceRegistration": {
              "name": "bceRegistration",
              "isArray": false,
              "type": {
                "enum": "CompanyCheckpointsBceRegistration"
              },
              "isRequired": false,
              "attributes": []
            },
            "shareholderAgreement": {
              "name": "shareholderAgreement",
              "isArray": false,
              "type": {
                "enum": "CompanyCheckpointsShareholderAgreement"
              },
              "isRequired": false,
              "attributes": []
            },
            "meetingDone": {
              "name": "meetingDone",
              "isArray": false,
              "type": {
                "enum": "CompanyCheckpointsMeetingDone"
              },
              "isRequired": false,
              "attributes": []
            },
            "owner": {
              "name": "owner",
              "isArray": false,
              "type": "String",
              "isRequired": false,
              "attributes": []
            },
            "companyOnboardingId": {
              "name": "companyOnboardingId",
              "isArray": false,
              "type": "ID",
              "isRequired": false,
              "attributes": []
            },
            "companyOnboarding": {
              "name": "companyOnboarding",
              "isArray": false,
              "type": {
                "model": "CompanyOnboarding"
              },
              "isRequired": false,
              "attributes": [],
              "association": {
                "connectionType": "BELONGS_TO",
                "targetNames": [
                  "companyOnboardingId"
                ]
              }
            },
            "documents": {
              "name": "documents",
              "isArray": true,
              "type": {
                "model": "CompanyOnboardingDocument"
              },
              "isRequired": false,
              "attributes": [],
              "isArrayNullable": true,
              "association": {
                "connectionType": "HAS_MANY",
                "associatedWith": [
                  "checkpointId"
                ]
              }
            },
            "createdAt": {
              "name": "createdAt",
              "isArray": false,
              "type": "AWSDateTime",
              "isRequired": false,
              "attributes": [],
              "isReadOnly": true
            },
            "updatedAt": {
              "name": "updatedAt",
              "isArray": false,
              "type": "AWSDateTime",
              "isRequired": false,
              "attributes": [],
              "isReadOnly": true
            }
          },
          "syncable": true,
          "pluralName": "CompanyCheckpoints",
          "attributes": [
            {
              "type": "model",
              "properties": {}
            },
            {
              "type": "key",
              "properties": {
                "fields": [
                  "id"
                ]
              }
            },
            {
              "type": "auth",
              "properties": {
                "rules": [
                  {
                    "provider": "userPools",
                    "ownerField": "owner",
                    "allow": "owner",
                    "operations": [
                      "read"
                    ],
                    "identityClaim": "cognito:username"
                  },
                  {
                    "groupClaim": "cognito:groups",
                    "provider": "userPools",
                    "allow": "groups",
                    "groups": [
                      "ADMINS"
                    ],
                    "operations": [
                      "create",
                      "update",
                      "delete",
                      "read"
                    ]
                  }
                ]
              }
            }
          ],
          "primaryKeyInfo": {
            "isCustomPrimaryKey": false,
            "primaryKeyFieldName": "id",
            "sortKeyFieldNames": []
          }
        },
        "CompanyComment": {
          "name": "CompanyComment",
          "fields": {
            "id": {
              "name": "id",
              "isArray": false,
              "type": "ID",
              "isRequired": true,
              "attributes": []
            },
            "companyOnboardingId": {
              "name": "companyOnboardingId",
              "isArray": false,
              "type": "ID",
              "isRequired": true,
              "attributes": []
            },
            "companyOnboarding": {
              "name": "companyOnboarding",
              "isArray": false,
              "type": {
                "model": "CompanyOnboarding"
              },
              "isRequired": false,
              "attributes": [],
              "association": {
                "connectionType": "BELONGS_TO",
                "targetNames": [
                  "companyOnboardingId"
                ]
              }
            },
            "content": {
              "name": "content",
              "isArray": false,
              "type": "String",
              "isRequired": true,
              "attributes": []
            },
            "authorName": {
              "name": "authorName",
              "isArray": false,
              "type": "String",
              "isRequired": false,
              "attributes": []
            },
            "authorRole": {
              "name": "authorRole",
              "isArray": false,
              "type": "String",
              "isRequired": false,
              "attributes": []
            },
            "recipientSubs": {
              "name": "recipientSubs",
              "isArray": true,
              "type": "String",
              "isRequired": false,
              "attributes": [],
              "isArrayNullable": true
            },
            "recipientNames": {
              "name": "recipientNames",
              "isArray": true,
              "type": "String",
              "isRequired": false,
              "attributes": [],
              "isArrayNullable": true
            },
            "status": {
              "name": "status",
              "isArray": false,
              "type": {
                "enum": "CompanyCommentStatus"
              },
              "isRequired": false,
              "attributes": []
            },
            "isEdited": {
              "name": "isEdited",
              "isArray": false,
              "type": "Boolean",
              "isRequired": false,
              "attributes": []
            },
            "notificationIds": {
              "name": "notificationIds",
              "isArray": true,
              "type": "String",
              "isRequired": false,
              "attributes": [],
              "isArrayNullable": true
            },
            "kind": {
              "name": "kind",
              "isArray": false,
              "type": {
                "enum": "CompanyCommentKind"
              },
              "isRequired": false,
              "attributes": []
            },
            "emailQueueId": {
              "name": "emailQueueId",
              "isArray": false,
              "type": "String",
              "isRequired": false,
              "attributes": []
            },
            "emailStatus": {
              "name": "emailStatus",
              "isArray": false,
              "type": {
                "enum": "CompanyCommentEmailStatus"
              },
              "isRequired": false,
              "attributes": []
            },
            "emailRecipient": {
              "name": "emailRecipient",
              "isArray": false,
              "type": "String",
              "isRequired": false,
              "attributes": []
            },
            "emailTemplateId": {
              "name": "emailTemplateId",
              "isArray": false,
              "type": "Int",
              "isRequired": false,
              "attributes": []
            },
            "owner": {
              "name": "owner",
              "isArray": false,
              "type": "String",
              "isRequired": false,
              "attributes": []
            },
            "createdAt": {
              "name": "createdAt",
              "isArray": false,
              "type": "AWSDateTime",
              "isRequired": false,
              "attributes": [],
              "isReadOnly": true
            },
            "updatedAt": {
              "name": "updatedAt",
              "isArray": false,
              "type": "AWSDateTime",
              "isRequired": false,
              "attributes": [],
              "isReadOnly": true
            }
          },
          "syncable": true,
          "pluralName": "CompanyComments",
          "attributes": [
            {
              "type": "model",
              "properties": {}
            },
            {
              "type": "key",
              "properties": {
                "fields": [
                  "id"
                ]
              }
            },
            {
              "type": "key",
              "properties": {
                "name": "companyCommentsByCompanyOnboardingId",
                "queryField": "listCompanyCommentByCompanyOnboardingId",
                "fields": [
                  "companyOnboardingId"
                ]
              }
            },
            {
              "type": "auth",
              "properties": {
                "rules": [
                  {
                    "groupClaim": "cognito:groups",
                    "provider": "userPools",
                    "allow": "groups",
                    "operations": [
                      "create",
                      "read"
                    ],
                    "groups": [
                      "ADMINS"
                    ]
                  },
                  {
                    "provider": "userPools",
                    "ownerField": "owner",
                    "allow": "owner",
                    "identityClaim": "cognito:username",
                    "operations": [
                      "create",
                      "update",
                      "delete",
                      "read"
                    ]
                  }
                ]
              }
            }
          ],
          "primaryKeyInfo": {
            "isCustomPrimaryKey": false,
            "primaryKeyFieldName": "id",
            "sortKeyFieldNames": []
          }
        },
        "Log": {
          "name": "Log",
          "fields": {
            "id": {
              "name": "id",
              "isArray": false,
              "type": "ID",
              "isRequired": true,
              "attributes": []
            },
            "type": {
              "name": "type",
              "isArray": false,
              "type": {
                "enum": "LogType"
              },
              "isRequired": false,
              "attributes": []
            },
            "message": {
              "name": "message",
              "isArray": false,
              "type": "String",
              "isRequired": true,
              "attributes": []
            },
            "details": {
              "name": "details",
              "isArray": false,
              "type": "String",
              "isRequired": false,
              "attributes": []
            },
            "source": {
              "name": "source",
              "isArray": false,
              "type": "String",
              "isRequired": true,
              "attributes": []
            },
            "action": {
              "name": "action",
              "isArray": false,
              "type": "String",
              "isRequired": false,
              "attributes": []
            },
            "userId": {
              "name": "userId",
              "isArray": false,
              "type": "ID",
              "isRequired": false,
              "attributes": []
            },
            "companyId": {
              "name": "companyId",
              "isArray": false,
              "type": "ID",
              "isRequired": false,
              "attributes": []
            },
            "sessionId": {
              "name": "sessionId",
              "isArray": false,
              "type": "String",
              "isRequired": false,
              "attributes": []
            },
            "requestId": {
              "name": "requestId",
              "isArray": false,
              "type": "String",
              "isRequired": false,
              "attributes": []
            },
            "userAgent": {
              "name": "userAgent",
              "isArray": false,
              "type": "String",
              "isRequired": false,
              "attributes": []
            },
            "ipAddress": {
              "name": "ipAddress",
              "isArray": false,
              "type": "String",
              "isRequired": false,
              "attributes": []
            },
            "errorCode": {
              "name": "errorCode",
              "isArray": false,
              "type": "String",
              "isRequired": false,
              "attributes": []
            },
            "stackTrace": {
              "name": "stackTrace",
              "isArray": false,
              "type": "String",
              "isRequired": false,
              "attributes": []
            },
            "metadata": {
              "name": "metadata",
              "isArray": false,
              "type": "AWSJSON",
              "isRequired": false,
              "attributes": []
            },
            "logPartition": {
              "name": "logPartition",
              "isArray": false,
              "type": "String",
              "isRequired": false,
              "attributes": []
            },
            "createdAt": {
              "name": "createdAt",
              "isArray": false,
              "type": "AWSDateTime",
              "isRequired": false,
              "attributes": []
            },
            "updatedAt": {
              "name": "updatedAt",
              "isArray": false,
              "type": "AWSDateTime",
              "isRequired": false,
              "attributes": [],
              "isReadOnly": true
            }
          },
          "syncable": true,
          "pluralName": "Logs",
          "attributes": [
            {
              "type": "model",
              "properties": {}
            },
            {
              "type": "key",
              "properties": {
                "name": "logsByLogPartitionAndCreatedAt",
                "queryField": "listLogByLogPartitionAndCreatedAt",
                "fields": [
                  "logPartition",
                  "createdAt"
                ]
              }
            },
            {
              "type": "auth",
              "properties": {
                "rules": [
                  {
                    "provider": "userPools",
                    "ownerField": "owner",
                    "allow": "owner",
                    "operations": [
                      "create",
                      "read"
                    ],
                    "identityClaim": "cognito:username"
                  },
                  {
                    "groupClaim": "cognito:groups",
                    "provider": "userPools",
                    "allow": "groups",
                    "groups": [
                      "ADMINS"
                    ],
                    "operations": [
                      "create",
                      "update",
                      "delete",
                      "read"
                    ]
                  }
                ]
              }
            }
          ],
          "primaryKeyInfo": {
            "isCustomPrimaryKey": false,
            "primaryKeyFieldName": "id",
            "sortKeyFieldNames": []
          }
        },
        "OnboardingManager": {
          "name": "OnboardingManager",
          "fields": {
            "id": {
              "name": "id",
              "isArray": false,
              "type": "ID",
              "isRequired": true,
              "attributes": []
            },
            "sub": {
              "name": "sub",
              "isArray": false,
              "type": "String",
              "isRequired": false,
              "attributes": []
            },
            "name": {
              "name": "name",
              "isArray": false,
              "type": "String",
              "isRequired": false,
              "attributes": []
            },
            "email": {
              "name": "email",
              "isArray": false,
              "type": "String",
              "isRequired": false,
              "attributes": []
            },
            "language": {
              "name": "language",
              "isArray": false,
              "type": {
                "enum": "OnboardingManagerLanguage"
              },
              "isRequired": false,
              "attributes": []
            },
            "active": {
              "name": "active",
              "isArray": false,
              "type": "Boolean",
              "isRequired": false,
              "attributes": []
            },
            "lastAssignedAt": {
              "name": "lastAssignedAt",
              "isArray": false,
              "type": "AWSDateTime",
              "isRequired": false,
              "attributes": []
            },
            "createdAt": {
              "name": "createdAt",
              "isArray": false,
              "type": "AWSDateTime",
              "isRequired": false,
              "attributes": [],
              "isReadOnly": true
            },
            "updatedAt": {
              "name": "updatedAt",
              "isArray": false,
              "type": "AWSDateTime",
              "isRequired": false,
              "attributes": [],
              "isReadOnly": true
            }
          },
          "syncable": true,
          "pluralName": "OnboardingManagers",
          "attributes": [
            {
              "type": "model",
              "properties": {}
            },
            {
              "type": "key",
              "properties": {
                "fields": [
                  "id"
                ]
              }
            },
            {
              "type": "key",
              "properties": {
                "name": "onboardingManagersBySub",
                "queryField": "listOnboardingManagerBySub",
                "fields": [
                  "sub"
                ]
              }
            },
            {
              "type": "auth",
              "properties": {
                "rules": [
                  {
                    "groupClaim": "cognito:groups",
                    "provider": "userPools",
                    "allow": "groups",
                    "groups": [
                      "ADMINS"
                    ],
                    "operations": [
                      "create",
                      "update",
                      "delete",
                      "read"
                    ]
                  }
                ]
              }
            }
          ],
          "primaryKeyInfo": {
            "isCustomPrimaryKey": false,
            "primaryKeyFieldName": "id",
            "sortKeyFieldNames": []
          }
        },
        "Users": {
          "name": "Users",
          "fields": {
            "id": {
              "name": "id",
              "isArray": false,
              "type": "ID",
              "isRequired": true,
              "attributes": []
            },
            "username": {
              "name": "username",
              "isArray": false,
              "type": "String",
              "isRequired": false,
              "attributes": []
            },
            "email": {
              "name": "email",
              "isArray": false,
              "type": "String",
              "isRequired": true,
              "attributes": []
            },
            "given_name": {
              "name": "given_name",
              "isArray": false,
              "type": "String",
              "isRequired": false,
              "attributes": []
            },
            "family_name": {
              "name": "family_name",
              "isArray": false,
              "type": "String",
              "isRequired": false,
              "attributes": []
            },
            "phone_number": {
              "name": "phone_number",
              "isArray": false,
              "type": "String",
              "isRequired": false,
              "attributes": []
            },
            "preferred_language": {
              "name": "preferred_language",
              "isArray": false,
              "type": "String",
              "isRequired": false,
              "attributes": []
            },
            "sub": {
              "name": "sub",
              "isArray": false,
              "type": "String",
              "isRequired": true,
              "attributes": []
            },
            "createdAt": {
              "name": "createdAt",
              "isArray": false,
              "type": "AWSDateTime",
              "isRequired": false,
              "attributes": [],
              "isReadOnly": true
            },
            "updatedAt": {
              "name": "updatedAt",
              "isArray": false,
              "type": "AWSDateTime",
              "isRequired": false,
              "attributes": [],
              "isReadOnly": true
            }
          },
          "syncable": true,
          "pluralName": "Users",
          "attributes": [
            {
              "type": "model",
              "properties": {}
            },
            {
              "type": "key",
              "properties": {
                "fields": [
                  "id"
                ]
              }
            },
            {
              "type": "key",
              "properties": {
                "name": "usersByEmail",
                "queryField": "listUsersByEmail",
                "fields": [
                  "email"
                ]
              }
            },
            {
              "type": "key",
              "properties": {
                "name": "usersBySub",
                "queryField": "listUsersBySub",
                "fields": [
                  "sub"
                ]
              }
            },
            {
              "type": "auth",
              "properties": {
                "rules": [
                  {
                    "provider": "userPools",
                    "ownerField": "sub",
                    "allow": "owner",
                    "identityClaim": "sub",
                    "operations": [
                      "create",
                      "update",
                      "delete",
                      "read"
                    ]
                  },
                  {
                    "groupClaim": "cognito:groups",
                    "provider": "userPools",
                    "allow": "groups",
                    "groups": [
                      "ADMINS"
                    ],
                    "operations": [
                      "create",
                      "update",
                      "delete",
                      "read"
                    ]
                  }
                ]
              }
            }
          ],
          "primaryKeyInfo": {
            "isCustomPrimaryKey": false,
            "primaryKeyFieldName": "id",
            "sortKeyFieldNames": []
          }
        },
        "EmailQueue": {
          "name": "EmailQueue",
          "fields": {
            "id": {
              "name": "id",
              "isArray": false,
              "type": "ID",
              "isRequired": true,
              "attributes": []
            },
            "status": {
              "name": "status",
              "isArray": false,
              "type": {
                "enum": "EmailQueueStatus"
              },
              "isRequired": false,
              "attributes": []
            },
            "templateId": {
              "name": "templateId",
              "isArray": false,
              "type": "Int",
              "isRequired": false,
              "attributes": []
            },
            "recipientEmail": {
              "name": "recipientEmail",
              "isArray": false,
              "type": "String",
              "isRequired": true,
              "attributes": []
            },
            "recipientName": {
              "name": "recipientName",
              "isArray": false,
              "type": "String",
              "isRequired": false,
              "attributes": []
            },
            "variables": {
              "name": "variables",
              "isArray": false,
              "type": "AWSJSON",
              "isRequired": false,
              "attributes": []
            },
            "relatedEntityId": {
              "name": "relatedEntityId",
              "isArray": false,
              "type": "String",
              "isRequired": false,
              "attributes": []
            },
            "relatedEntityType": {
              "name": "relatedEntityType",
              "isArray": false,
              "type": "String",
              "isRequired": false,
              "attributes": []
            },
            "retryCount": {
              "name": "retryCount",
              "isArray": false,
              "type": "Int",
              "isRequired": false,
              "attributes": []
            },
            "error": {
              "name": "error",
              "isArray": false,
              "type": "String",
              "isRequired": false,
              "attributes": []
            },
            "createdAt": {
              "name": "createdAt",
              "isArray": false,
              "type": "AWSDateTime",
              "isRequired": false,
              "attributes": [],
              "isReadOnly": true
            },
            "updatedAt": {
              "name": "updatedAt",
              "isArray": false,
              "type": "AWSDateTime",
              "isRequired": false,
              "attributes": [],
              "isReadOnly": true
            }
          },
          "syncable": true,
          "pluralName": "EmailQueues",
          "attributes": [
            {
              "type": "model",
              "properties": {}
            },
            {
              "type": "auth",
              "properties": {
                "rules": [
                  {
                    "groupClaim": "cognito:groups",
                    "provider": "userPools",
                    "allow": "groups",
                    "groups": [
                      "ADMINS"
                    ],
                    "operations": [
                      "create",
                      "update",
                      "delete",
                      "read"
                    ]
                  }
                ]
              }
            }
          ],
          "primaryKeyInfo": {
            "isCustomPrimaryKey": false,
            "primaryKeyFieldName": "id",
            "sortKeyFieldNames": []
          }
        },
        "Payment": {
          "name": "Payment",
          "fields": {
            "id": {
              "name": "id",
              "isArray": false,
              "type": "ID",
              "isRequired": true,
              "attributes": []
            },
            "stripeCheckoutSessionId": {
              "name": "stripeCheckoutSessionId",
              "isArray": false,
              "type": "String",
              "isRequired": true,
              "attributes": []
            },
            "stripeCustomerEmail": {
              "name": "stripeCustomerEmail",
              "isArray": false,
              "type": "String",
              "isRequired": false,
              "attributes": []
            },
            "stripeCustomerName": {
              "name": "stripeCustomerName",
              "isArray": false,
              "type": "String",
              "isRequired": false,
              "attributes": []
            },
            "productName": {
              "name": "productName",
              "isArray": false,
              "type": "String",
              "isRequired": false,
              "attributes": []
            },
            "productId": {
              "name": "productId",
              "isArray": false,
              "type": "String",
              "isRequired": false,
              "attributes": []
            },
            "amount": {
              "name": "amount",
              "isArray": false,
              "type": "Int",
              "isRequired": false,
              "attributes": []
            },
            "currency": {
              "name": "currency",
              "isArray": false,
              "type": "String",
              "isRequired": false,
              "attributes": []
            },
            "paymentStatus": {
              "name": "paymentStatus",
              "isArray": false,
              "type": "String",
              "isRequired": true,
              "attributes": []
            },
            "companyOnboardingId": {
              "name": "companyOnboardingId",
              "isArray": false,
              "type": "String",
              "isRequired": false,
              "attributes": []
            },
            "userSub": {
              "name": "userSub",
              "isArray": false,
              "type": "String",
              "isRequired": false,
              "attributes": []
            },
            "metadata": {
              "name": "metadata",
              "isArray": false,
              "type": "AWSJSON",
              "isRequired": false,
              "attributes": []
            },
            "eventType": {
              "name": "eventType",
              "isArray": false,
              "type": "String",
              "isRequired": false,
              "attributes": []
            },
            "processed": {
              "name": "processed",
              "isArray": false,
              "type": "Boolean",
              "isRequired": false,
              "attributes": []
            },
            "processingError": {
              "name": "processingError",
              "isArray": false,
              "type": "String",
              "isRequired": false,
              "attributes": []
            },
            "reminderChecked": {
              "name": "reminderChecked",
              "isArray": false,
              "type": "Boolean",
              "isRequired": false,
              "attributes": []
            },
            "createdAt": {
              "name": "createdAt",
              "isArray": false,
              "type": "AWSDateTime",
              "isRequired": false,
              "attributes": []
            },
            "updatedAt": {
              "name": "updatedAt",
              "isArray": false,
              "type": "AWSDateTime",
              "isRequired": false,
              "attributes": []
            }
          },
          "syncable": true,
          "pluralName": "Payments",
          "attributes": [
            {
              "type": "model",
              "properties": {}
            },
            {
              "type": "key",
              "properties": {
                "fields": [
                  "id"
                ]
              }
            },
            {
              "type": "key",
              "properties": {
                "name": "paymentsByStripeCheckoutSessionId",
                "queryField": "listPaymentByStripeCheckoutSessionId",
                "fields": [
                  "stripeCheckoutSessionId"
                ]
              }
            },
            {
              "type": "key",
              "properties": {
                "name": "paymentsByStripeCustomerEmail",
                "queryField": "listPaymentByStripeCustomerEmail",
                "fields": [
                  "stripeCustomerEmail"
                ]
              }
            },
            {
              "type": "key",
              "properties": {
                "name": "paymentsByCompanyOnboardingId",
                "queryField": "listPaymentByCompanyOnboardingId",
                "fields": [
                  "companyOnboardingId"
                ]
              }
            },
            {
              "type": "key",
              "properties": {
                "name": "paymentsByUserSub",
                "queryField": "listPaymentByUserSub",
                "fields": [
                  "userSub"
                ]
              }
            },
            {
              "type": "auth",
              "properties": {
                "rules": [
                  {
                    "groupClaim": "cognito:groups",
                    "provider": "userPools",
                    "allow": "groups",
                    "groups": [
                      "ADMINS"
                    ],
                    "operations": [
                      "create",
                      "update",
                      "delete",
                      "read"
                    ]
                  }
                ]
              }
            }
          ],
          "primaryKeyInfo": {
            "isCustomPrimaryKey": false,
            "primaryKeyFieldName": "id",
            "sortKeyFieldNames": []
          }
        },
        "InternalNotification": {
          "name": "InternalNotification",
          "fields": {
            "id": {
              "name": "id",
              "isArray": false,
              "type": "ID",
              "isRequired": true,
              "attributes": []
            },
            "senderSub": {
              "name": "senderSub",
              "isArray": false,
              "type": "String",
              "isRequired": true,
              "attributes": []
            },
            "senderName": {
              "name": "senderName",
              "isArray": false,
              "type": "String",
              "isRequired": false,
              "attributes": []
            },
            "recipientSub": {
              "name": "recipientSub",
              "isArray": false,
              "type": "String",
              "isRequired": false,
              "attributes": []
            },
            "recipientName": {
              "name": "recipientName",
              "isArray": false,
              "type": "String",
              "isRequired": false,
              "attributes": []
            },
            "read": {
              "name": "read",
              "isArray": false,
              "type": "Boolean",
              "isRequired": false,
              "attributes": []
            },
            "type": {
              "name": "type",
              "isArray": false,
              "type": {
                "enum": "InternalNotificationContentType"
              },
              "isRequired": false,
              "attributes": []
            },
            "typeLinkId": {
              "name": "typeLinkId",
              "isArray": false,
              "type": "String",
              "isRequired": false,
              "attributes": []
            },
            "companyOnboardingId": {
              "name": "companyOnboardingId",
              "isArray": false,
              "type": "ID",
              "isRequired": false,
              "attributes": []
            },
            "companyName": {
              "name": "companyName",
              "isArray": false,
              "type": "String",
              "isRequired": false,
              "attributes": []
            },
            "isEdited": {
              "name": "isEdited",
              "isArray": false,
              "type": "Boolean",
              "isRequired": false,
              "attributes": []
            },
            "content": {
              "name": "content",
              "isArray": false,
              "type": {
                "nonModel": "InternalNotificationTextContent"
              },
              "isRequired": false,
              "attributes": []
            },
            "createdAt": {
              "name": "createdAt",
              "isArray": false,
              "type": "AWSDateTime",
              "isRequired": false,
              "attributes": []
            },
            "updatedAt": {
              "name": "updatedAt",
              "isArray": false,
              "type": "AWSDateTime",
              "isRequired": false,
              "attributes": [],
              "isReadOnly": true
            }
          },
          "syncable": true,
          "pluralName": "InternalNotifications",
          "attributes": [
            {
              "type": "model",
              "properties": {}
            },
            {
              "type": "key",
              "properties": {
                "fields": [
                  "id"
                ]
              }
            },
            {
              "type": "key",
              "properties": {
                "name": "internalNotificationsByRecipientSubAndCreatedAt",
                "queryField": "listInternalNotificationByRecipientSubAndCreatedAt",
                "fields": [
                  "recipientSub",
                  "createdAt"
                ]
              }
            },
            {
              "type": "auth",
              "properties": {
                "rules": [
                  {
                    "provider": "userPools",
                    "ownerField": "recipientSub",
                    "allow": "owner",
                    "identityClaim": "cognito:username",
                    "operations": [
                      "create",
                      "update",
                      "delete",
                      "read"
                    ]
                  },
                  {
                    "provider": "userPools",
                    "ownerField": "senderSub",
                    "allow": "owner",
                    "identityClaim": "cognito:username",
                    "operations": [
                      "create",
                      "update",
                      "delete",
                      "read"
                    ]
                  },
                  {
                    "groupClaim": "cognito:groups",
                    "provider": "userPools",
                    "allow": "groups",
                    "operations": [
                      "create"
                    ],
                    "groups": [
                      "ADMINS"
                    ]
                  }
                ]
              }
            }
          ],
          "primaryKeyInfo": {
            "isCustomPrimaryKey": false,
            "primaryKeyFieldName": "id",
            "sortKeyFieldNames": []
          }
        }
      },
      "enums": {
        "InternalNotificationContentType": {
          "name": "InternalNotificationContentType",
          "values": [
            "TEXT",
            "COMMENT"
          ]
        },
        "CompanyOnboardingPaymentMethod": {
          "name": "CompanyOnboardingPaymentMethod",
          "values": [
            "STRIPE",
            "WIRE_TRANSFER"
          ]
        },
        "CompanyOnboardingStatus": {
          "name": "CompanyOnboardingStatus",
          "values": [
            "DRAFT",
            "INPROGRESS",
            "COMPLETED"
          ]
        },
        "CompanyOnboardingOnboardingStatus": {
          "name": "CompanyOnboardingOnboardingStatus",
          "values": [
            "NEW",
            "CONSTITUTION_IN_PROGRESS",
            "CONSTITUTION_COMPLETED",
            "ABANDONED",
            "DELETED"
          ]
        },
        "CompanyOnboardingAccountantReviewStatus": {
          "name": "CompanyOnboardingAccountantReviewStatus",
          "values": [
            "PENDING",
            "WAITING_INFO",
            "APPROVED"
          ]
        },
        "CompanyOnboardingDocumentDocumentType": {
          "name": "CompanyOnboardingDocumentDocumentType",
          "values": [
            "IDENTITY_DOCUMENT",
            "IDENTITY_DOCUMENT_FRONT",
            "IDENTITY_DOCUMENT_BACK",
            "RESIDENCE_PROOF",
            "FINANCIAL_PLAN",
            "VAT_REGISTRATION",
            "NOTARIAL_DEED",
            "UBO_REGISTER",
            "BCE_REGISTRATION",
            "SHAREHOLDER_AGREEMENT",
            "OTHER"
          ]
        },
        "CompanyCheckpointsFinancialPlan": {
          "name": "CompanyCheckpointsFinancialPlan",
          "values": [
            "DONE",
            "WARNING",
            "ERROR",
            "PENDING"
          ]
        },
        "CompanyCheckpointsVatRegistration": {
          "name": "CompanyCheckpointsVatRegistration",
          "values": [
            "DONE",
            "WARNING",
            "ERROR",
            "PENDING"
          ]
        },
        "CompanyCheckpointsNotarialDeed": {
          "name": "CompanyCheckpointsNotarialDeed",
          "values": [
            "DONE",
            "WARNING",
            "ERROR",
            "PENDING"
          ]
        },
        "CompanyCheckpointsUboRegister": {
          "name": "CompanyCheckpointsUboRegister",
          "values": [
            "DONE",
            "WARNING",
            "ERROR",
            "PENDING"
          ]
        },
        "CompanyCheckpointsBceRegistration": {
          "name": "CompanyCheckpointsBceRegistration",
          "values": [
            "DONE",
            "WARNING",
            "ERROR",
            "PENDING"
          ]
        },
        "CompanyCheckpointsShareholderAgreement": {
          "name": "CompanyCheckpointsShareholderAgreement",
          "values": [
            "DONE",
            "WARNING",
            "ERROR",
            "PENDING"
          ]
        },
        "CompanyCheckpointsMeetingDone": {
          "name": "CompanyCheckpointsMeetingDone",
          "values": [
            "DONE",
            "WARNING",
            "ERROR",
            "PENDING"
          ]
        },
        "CompanyCommentStatus": {
          "name": "CompanyCommentStatus",
          "values": [
            "ACTIVE",
            "DELETED"
          ]
        },
        "CompanyCommentKind": {
          "name": "CompanyCommentKind",
          "values": [
            "USER",
            "SYSTEM",
            "EMAIL"
          ]
        },
        "CompanyCommentEmailStatus": {
          "name": "CompanyCommentEmailStatus",
          "values": [
            "SENT",
            "FAILED"
          ]
        },
        "LogType": {
          "name": "LogType",
          "values": [
            "INFO",
            "WARN",
            "ERROR",
            "DEBUG"
          ]
        },
        "OnboardingManagerLanguage": {
          "name": "OnboardingManagerLanguage",
          "values": [
            "FR",
            "NL"
          ]
        },
        "EmailQueueStatus": {
          "name": "EmailQueueStatus",
          "values": [
            "PENDING",
            "SENT",
            "FAILED"
          ]
        },
        "CompanyOnboardingFinancialDataFundReleaseMode": {
          "name": "CompanyOnboardingFinancialDataFundReleaseMode",
          "values": [
            "BEFORE_NOTARIAL_ACT",
            "AFTER_NOTARIAL_ACT"
          ]
        },
        "CompanyOnboardingFinancialDataMonthlyInvoicingLocation": {
          "name": "CompanyOnboardingFinancialDataMonthlyInvoicingLocation",
          "values": [
            "BELGIUM",
            "ABROAD"
          ]
        },
        "RemunerationsDataRole": {
          "name": "RemunerationsDataRole",
          "values": [
            "EXECUTIVES",
            "EMPLOYEES",
            "WORKERS"
          ]
        },
        "MobilityType": {
          "name": "MobilityType",
          "values": [
            "CAR",
            "MOTO",
            "PUBLIC_TRANSPORT",
            "BIKE"
          ]
        },
        "MobilityEnergyType": {
          "name": "MobilityEnergyType",
          "values": [
            "FUEL",
            "ELECTRIC",
            "HYBRID"
          ]
        },
        "WorkspaceType": {
          "name": "WorkspaceType",
          "values": [
            "RENT_AND_CHARGES",
            "LICENSES_SUBSCRIPTIONS",
            "CONSUMABLE",
            "OTHER"
          ]
        },
        "WorkspaceFrequency": {
          "name": "WorkspaceFrequency",
          "values": [
            "MONTHLY",
            "QUARTERLY",
            "SEMIANNUAL",
            "ANNUAL"
          ]
        },
        "ExternalServicesType": {
          "name": "ExternalServicesType",
          "values": [
            "ACCOUNTANT",
            "INSURANCE",
            "LOYER",
            "OTHER"
          ]
        },
        "ExternalServicesFrequency": {
          "name": "ExternalServicesFrequency",
          "values": [
            "MONTHLY",
            "QUARTERLY",
            "SEMIANNUAL",
            "ANNUAL"
          ]
        },
        "InvestmentsType": {
          "name": "InvestmentsType",
          "values": [
            "TOOLS",
            "HARDWARE",
            "OTHER",
            "CONSTITUTION_FEES"
          ]
        }
      },
      "nonModels": {
        "CompanyOnboardingFinancialData": {
          "name": "CompanyOnboardingFinancialData",
          "fields": {
            "capitalContribution": {
              "name": "capitalContribution",
              "isArray": false,
              "type": "Float",
              "isRequired": false,
              "attributes": []
            },
            "firstFiscalYearEndDate": {
              "name": "firstFiscalYearEndDate",
              "isArray": false,
              "type": "AWSDate",
              "isRequired": false,
              "attributes": []
            },
            "fundReleaseMode": {
              "name": "fundReleaseMode",
              "isArray": false,
              "type": {
                "enum": "CompanyOnboardingFinancialDataFundReleaseMode"
              },
              "isRequired": false,
              "attributes": []
            },
            "monthlyInvoicingAmount": {
              "name": "monthlyInvoicingAmount",
              "isArray": false,
              "type": "Float",
              "isRequired": false,
              "attributes": []
            },
            "monthlyInvoicingStartDate": {
              "name": "monthlyInvoicingStartDate",
              "isArray": false,
              "type": "AWSDate",
              "isRequired": false,
              "attributes": []
            },
            "monthlyInvoicingLocation": {
              "name": "monthlyInvoicingLocation",
              "isArray": false,
              "type": {
                "enum": "CompanyOnboardingFinancialDataMonthlyInvoicingLocation"
              },
              "isRequired": false,
              "attributes": []
            },
            "monthlyInvoicingAbroadProportion": {
              "name": "monthlyInvoicingAbroadProportion",
              "isArray": false,
              "type": "Float",
              "isRequired": false,
              "attributes": []
            },
            "needsGoodsPurchase": {
              "name": "needsGoodsPurchase",
              "isArray": false,
              "type": "Boolean",
              "isRequired": false,
              "attributes": []
            },
            "needsGoodsPurchaseMonthlyAmount": {
              "name": "needsGoodsPurchaseMonthlyAmount",
              "isArray": false,
              "type": "Float",
              "isRequired": false,
              "attributes": []
            },
            "needsSubcontracting": {
              "name": "needsSubcontracting",
              "isArray": false,
              "type": "Boolean",
              "isRequired": false,
              "attributes": []
            },
            "needsSubcontractingMonthlyAmount": {
              "name": "needsSubcontractingMonthlyAmount",
              "isArray": false,
              "type": "Float",
              "isRequired": false,
              "attributes": []
            },
            "remunerations": {
              "name": "remunerations",
              "isArray": true,
              "type": {
                "nonModel": "RemunerationsData"
              },
              "isRequired": false,
              "attributes": [],
              "isArrayNullable": true
            },
            "remunerationZeroExplanation": {
              "name": "remunerationZeroExplanation",
              "isArray": false,
              "type": "String",
              "isRequired": false,
              "attributes": []
            },
            "mobility": {
              "name": "mobility",
              "isArray": true,
              "type": {
                "nonModel": "Mobility"
              },
              "isRequired": false,
              "attributes": [],
              "isArrayNullable": true
            },
            "mobilityNone": {
              "name": "mobilityNone",
              "isArray": false,
              "type": "Boolean",
              "isRequired": false,
              "attributes": []
            },
            "workspace": {
              "name": "workspace",
              "isArray": true,
              "type": {
                "nonModel": "Workspace"
              },
              "isRequired": false,
              "attributes": [],
              "isArrayNullable": true
            },
            "externalServices": {
              "name": "externalServices",
              "isArray": true,
              "type": {
                "nonModel": "ExternalServices"
              },
              "isRequired": false,
              "attributes": [],
              "isArrayNullable": true
            },
            "investments": {
              "name": "investments",
              "isArray": true,
              "type": {
                "nonModel": "Investments"
              },
              "isRequired": false,
              "attributes": [],
              "isArrayNullable": true
            },
            "investmentLoanRequired": {
              "name": "investmentLoanRequired",
              "isArray": false,
              "type": "Boolean",
              "isRequired": false,
              "attributes": []
            },
            "investmentLoanAmount": {
              "name": "investmentLoanAmount",
              "isArray": false,
              "type": "Float",
              "isRequired": false,
              "attributes": []
            },
            "investmentLoanDurationMonths": {
              "name": "investmentLoanDurationMonths",
              "isArray": false,
              "type": "Float",
              "isRequired": false,
              "attributes": []
            },
            "investmentLoanStartDate": {
              "name": "investmentLoanStartDate",
              "isArray": false,
              "type": "AWSDate",
              "isRequired": false,
              "attributes": []
            },
            "annualInterestRate": {
              "name": "annualInterestRate",
              "isArray": false,
              "type": "Float",
              "isRequired": false,
              "attributes": []
            },
            "socialContributionsPaidByCompany": {
              "name": "socialContributionsPaidByCompany",
              "isArray": false,
              "type": "Boolean",
              "isRequired": false,
              "attributes": []
            }
          }
        },
        "RemunerationsData": {
          "name": "RemunerationsData",
          "fields": {
            "role": {
              "name": "role",
              "isArray": false,
              "type": {
                "enum": "RemunerationsDataRole"
              },
              "isRequired": false,
              "attributes": []
            },
            "monthlyNet": {
              "name": "monthlyNet",
              "isArray": false,
              "type": "Float",
              "isRequired": false,
              "attributes": []
            },
            "startDate": {
              "name": "startDate",
              "isArray": false,
              "type": "AWSDate",
              "isRequired": false,
              "attributes": []
            }
          }
        },
        "Mobility": {
          "name": "Mobility",
          "fields": {
            "type": {
              "name": "type",
              "isArray": false,
              "type": {
                "enum": "MobilityType"
              },
              "isRequired": false,
              "attributes": []
            },
            "energyType": {
              "name": "energyType",
              "isArray": false,
              "type": {
                "enum": "MobilityEnergyType"
              },
              "isRequired": false,
              "attributes": []
            },
            "monthlyNet": {
              "name": "monthlyNet",
              "isArray": false,
              "type": "Float",
              "isRequired": false,
              "attributes": []
            },
            "startDate": {
              "name": "startDate",
              "isArray": false,
              "type": "AWSDate",
              "isRequired": false,
              "attributes": []
            }
          }
        },
        "Workspace": {
          "name": "Workspace",
          "fields": {
            "type": {
              "name": "type",
              "isArray": false,
              "type": {
                "enum": "WorkspaceType"
              },
              "isRequired": false,
              "attributes": []
            },
            "frequency": {
              "name": "frequency",
              "isArray": false,
              "type": {
                "enum": "WorkspaceFrequency"
              },
              "isRequired": false,
              "attributes": []
            },
            "monthlyCost": {
              "name": "monthlyCost",
              "isArray": false,
              "type": "Float",
              "isRequired": false,
              "attributes": []
            },
            "label": {
              "name": "label",
              "isArray": false,
              "type": "String",
              "isRequired": false,
              "attributes": []
            },
            "startDate": {
              "name": "startDate",
              "isArray": false,
              "type": "AWSDate",
              "isRequired": false,
              "attributes": []
            }
          }
        },
        "ExternalServices": {
          "name": "ExternalServices",
          "fields": {
            "type": {
              "name": "type",
              "isArray": false,
              "type": {
                "enum": "ExternalServicesType"
              },
              "isRequired": false,
              "attributes": []
            },
            "frequency": {
              "name": "frequency",
              "isArray": false,
              "type": {
                "enum": "ExternalServicesFrequency"
              },
              "isRequired": false,
              "attributes": []
            },
            "monthlyCost": {
              "name": "monthlyCost",
              "isArray": false,
              "type": "Float",
              "isRequired": false,
              "attributes": []
            },
            "label": {
              "name": "label",
              "isArray": false,
              "type": "String",
              "isRequired": false,
              "attributes": []
            },
            "startDate": {
              "name": "startDate",
              "isArray": false,
              "type": "AWSDate",
              "isRequired": false,
              "attributes": []
            }
          }
        },
        "Investments": {
          "name": "Investments",
          "fields": {
            "type": {
              "name": "type",
              "isArray": false,
              "type": {
                "enum": "InvestmentsType"
              },
              "isRequired": false,
              "attributes": []
            },
            "label": {
              "name": "label",
              "isArray": false,
              "type": "String",
              "isRequired": false,
              "attributes": []
            },
            "totalCost": {
              "name": "totalCost",
              "isArray": false,
              "type": "Float",
              "isRequired": false,
              "attributes": []
            },
            "investmentDate": {
              "name": "investmentDate",
              "isArray": false,
              "type": "AWSDate",
              "isRequired": false,
              "attributes": []
            }
          }
        },
        "InternalNotificationTextContent": {
          "name": "InternalNotificationTextContent",
          "fields": {
            "title": {
              "name": "title",
              "isArray": false,
              "type": "String",
              "isRequired": false,
              "attributes": []
            },
            "text": {
              "name": "text",
              "isArray": false,
              "type": "String",
              "isRequired": true,
              "attributes": []
            }
          }
        }
      },
      "queries": {
        "payment": {
          "name": "payment",
          "isArray": false,
          "type": "AWSJSON",
          "isRequired": false,
          "arguments": {
            "action": {
              "name": "action",
              "isArray": false,
              "type": "String",
              "isRequired": false
            },
            "id": {
              "name": "id",
              "isArray": false,
              "type": "String",
              "isRequired": false
            },
            "data": {
              "name": "data",
              "isArray": false,
              "type": "AWSJSON",
              "isRequired": false
            }
          }
        },
        "email": {
          "name": "email",
          "isArray": false,
          "type": "AWSJSON",
          "isRequired": false,
          "arguments": {
            "templateId": {
              "name": "templateId",
              "isArray": false,
              "type": "Int",
              "isRequired": true
            },
            "to": {
              "name": "to",
              "isArray": true,
              "type": "String",
              "isRequired": false,
              "isArrayNullable": false
            },
            "params": {
              "name": "params",
              "isArray": false,
              "type": "AWSJSON",
              "isRequired": false
            }
          }
        },
        "userDetails": {
          "name": "userDetails",
          "isArray": false,
          "type": "AWSJSON",
          "isRequired": false,
          "arguments": {
            "userId": {
              "name": "userId",
              "isArray": false,
              "type": "String",
              "isRequired": true
            }
          }
        },
        "listAdmins": {
          "name": "listAdmins",
          "isArray": false,
          "type": "AWSJSON",
          "isRequired": false
        },
        "cleanupAbandoned": {
          "name": "cleanupAbandoned",
          "isArray": false,
          "type": "AWSJSON",
          "isRequired": false
        },
        "checkOnboardingIntegrity": {
          "name": "checkOnboardingIntegrity",
          "isArray": false,
          "type": "AWSJSON",
          "isRequired": false,
          "arguments": {
            "companyId": {
              "name": "companyId",
              "isArray": false,
              "type": "ID",
              "isRequired": false
            }
          }
        },
        "paymentReminders": {
          "name": "paymentReminders",
          "isArray": false,
          "type": "AWSJSON",
          "isRequired": false,
          "arguments": {
            "dryRun": {
              "name": "dryRun",
              "isArray": false,
              "type": "Boolean",
              "isRequired": false
            }
          }
        }
      }
    }
  },
  "storage": {
    "aws_region": "eu-west-1",
    "bucket_name": "amplify-d8h4l3ergqnrp-sta-mainstoragebucket39b3cec-x6nwmvhbi83y",
    "buckets": [
      {
        "name": "mainStorage",
        "bucket_name": "amplify-d8h4l3ergqnrp-sta-mainstoragebucket39b3cec-x6nwmvhbi83y",
        "aws_region": "eu-west-1",
        "paths": {
          "public/*": {
            "guest": [
              "get",
              "list"
            ],
            "authenticated": [
              "get",
              "list",
              "write",
              "delete"
            ]
          },
          "protected/*": {
            "authenticated": [
              "get",
              "list"
            ]
          },
          "protected/${cognito-identity.amazonaws.com:sub}/*": {
            "entityidentity": [
              "get",
              "list",
              "write",
              "delete"
            ]
          },
          "private/${cognito-identity.amazonaws.com:sub}/*": {
            "entityidentity": [
              "get",
              "list",
              "write",
              "delete"
            ]
          },
          "private/*": {
            "groupsADMINS": [
              "get",
              "list",
              "write",
              "delete"
            ]
          }
        }
      }
    ]
  },
  "version": "1.4",
  "custom": {
    "StripeWebhookAPI": {
      "endpoint": "https://jn9c6772r6.execute-api.eu-west-1.amazonaws.com/",
      "region": "eu-west-1",
      "webhookPath": "/webhook/stripe"
    },
    "CalendlyWebhookAPI": {
      "endpoint": "https://dhkgmo31c9.execute-api.eu-west-1.amazonaws.com/",
      "region": "eu-west-1",
      "webhookPath": "/webhook/calendly"
    }
  }
}